export default "__VITE_ASSET__Djd2L9cK__"